<template>
	<div>
		<section-sidebar>
<!--			<template v-for="(client, key) in clients">-->
<!--				<section-sidebar-item-->
<!--					:to="{ name: 'client', params: { id: client.id } }"-->
<!--					icon="building"-->
<!--					:key="key"-->
<!--					:caret="true"-->
<!--					noexact-->
<!--				>-->
<!--					{{ client.name }}-->
<!--				</section-sidebar-item>-->

<!--				<template v-if="onClient(client.id)">-->
<!--					<section-sidebar-item-->
<!--						:to="{ name: 'group-unassigned', params: { id: client.id } }"-->
<!--						icon="archive"-->
<!--						:key="key"-->
<!--						small-->
<!--						noexact-->
<!--					>-->
<!--						{{ $t('group.unassigned') }}-->
<!--					</section-sidebar-item>-->

<!--					<section-sidebar-tree-->
<!--						v-for="(group, groupKey) in client.parsed_groups"-->
<!--						:to="{ name: 'group', params: { id: client.id, groupId: '$id' } }"-->
<!--						idKey="id"-->
<!--						icon="layer-group"-->
<!--						:key="groupKey"-->
<!--						:node="group"-->
<!--						small-->
<!--						noexact-->
<!--					/>-->

<!--					&lt;!&ndash; <section-sidebar-item-->
<!--						:to="{ name: 'group', params: { id: client.id, groupId: group.id } }"-->
<!--						icon="layer-group"-->
<!--						v-for="(group, groupKey) in client.groups"-->
<!--						:key="groupKey"-->
<!--						small-->
<!--					>-->
<!--						{{ group.name }}-->
<!--					</section-sidebar-item> &ndash;&gt;-->
<!--				</template>-->
<!--			</template>-->
			<li class="w-100" @click="refresh" v-if="!sidebarLoading">
				<div class="px-2 py-2 d-flex align-items-center font-size">
					<div class="mr-auto truncate pointer">
						<b-button variant="link" class="client-text">Reload Sidebar</b-button>
					</div>
				</div>
			</li>
			<li v-else class="w-100 client-text">
				<div class="py-3 d-flex justify-content-center align-items-center font-size">
					<div class="truncate">
						<b-spinner></b-spinner>
					</div>
				</div>
			</li>
			<div v-if="!sidebarLoading">
				<sidebar-tree	root v-for="client in clients" :item="client" :key="'client_' + client.id" :client-id="client.id" resource="clients" />
			</div>
		</section-sidebar>

		<div class="app-section-contents">
			<router-view v-if="currentClient" />
		</div>
	</div>
</template>

<script>
import SectionSidebar from '../../components/layout/SectionSidebar';
import ErrorModal from '../../mixins/ErrorModal';
import SidebarTree from '../../components/layout/SidebarTree';

export default {
	components: {
		SectionSidebar,
		// SectionSidebarItem,
		// SectionSidebarTree,
		SidebarTree
	},
	mixins: [ ErrorModal ],
	data () {
		return {
			refreshTimer: null,
			// amount of time the timer should run: (milli) * (secs) * (mins)
			// refresh will happen every hour
			timerMilliseconds: ((1000) * (60) * (60)),
			sidebarLoading: true
		};
	},
	watch: {
		$route (to, from) {
			if (from.params.id !== to.params.id) {
				if (!this.newClientCanView(parseInt(to.params.id))) {
					this.$router.push('/');
				}
				else {
					this.$store.commit('clients/current', to.params.id);
				}
			}
		}
	},
	async mounted () {
		if (!this.canView) {
			this.$router.push('/');
		}
		else {
			await this.loadClients();

			const sidebarRequest = { client: this.$route.params.id };
			if (this.$route.params.groupId) sidebarRequest.group = this.$route.params.groupId;
			if (this.$route.params.deviceId) sidebarRequest.device = this.$route.params.deviceId;

			this.$store.dispatch('sidebar/fetchAll', sidebarRequest)
				.then(data => {
					// if we don't have any groups for the client, we will make an api call to retrieve them
					if (this.sidebarGroupCountForClient === 0) {
						const sidebarRequest = { client: this.$route.params.id };

						return this.$store.dispatch('sidebar/fetchClient', sidebarRequest);
					}
				})
				.catch(err => {
					this.showErrorModal(err, 'Error Retrieving Sidebar Data');
				})
				.then(data => {
					// data will either be empty or handled within the store's action
				})
				.catch(err => {
					this.showErrorModal(err, 'Error Retrieving Sidebar Data');
				})
				.finally(() => {
					this.sidebarLoading = false;
				});

			const routeId = parseInt(this.$route.params.id);
			this.$store.commit('clients/current', routeId);

			// start a timer to refresh the sidebar every so often
			this.startRefreshTimer();
		}
	},
	methods: {
		// TODO: We should move client loading functionality out of this generic section layout component
		async loadClients () {
			if (this.clients.length === 0) {
				return this.$store.dispatch('clients/refresh')
					.catch(e => {
						this.showErrorModal(e, 'Error Retrieving Client Data');
					});
			}
		},
		onClient (id) {
			return this.currentClient !== null && this.currentClient.id === parseInt(id);
		},
		getChildren (groups, group) {
			return groups.filter(g => {
				return g.id !== group.id && g.parent_group_id === group.id;
			});
		},
		refresh (showSuccess = true) {
			this.sidebarLoading = true;

			const sidebarRequest = { client: this.$route.params.id, clear_data: true };
			if (this.$route.params.groupId) sidebarRequest.group = this.$route.params.groupId;
			if (this.$route.params.deviceId) sidebarRequest.device = this.$route.params.deviceId;

			let dispatch = 'sidebar/fetchClient';
			if (sidebarRequest.group) dispatch = 'sidebar/fetchGroup';

			this.$store.dispatch(dispatch, sidebarRequest)
				.then(data => {
					if (showSuccess) {
						this.$bvModal.msgBoxOk('Sidebar successfully refreshed.', {
							headerBgVariant: 'success',
							headerTextVariant: 'white',
							okVariant: 'success',
							title: 'Success'
						});
					}
				})
				.catch(err => {
					this.showErrorModal(err, 'Error Refreshing Sidebar Content');
				})
				.finally(() => {
					this.sidebarLoading = false;
				});
		},
		startRefreshTimer () {
			this.refreshTimer = setTimeout(this.resetRefreshTimer, this.timerMilliseconds);
		},
		resetRefreshTimer () {
			// null out the reference to the old timer
			this.refreshTimer = null;
			// call a refresh for the sidebar
			this.refresh(false);
			// restart the timer to do it again
			this.startRefreshTimer();
		},
		isManageSlug (slug) {
			return slug.includes('manage_client') ||
				slug === 'super_admin';
		},
		newClientCanView (clientId) {
			return this.$store.getters['auth/hasPermission']('view_client', true, clientId) ||
				this.$store.getters['auth/hasPermission']('manage_client*', true, clientId);
		}
	},
	computed: {
		clients () {
			return [...this.$store.getters['sidebar/getClients']].sort((a, b) => {
				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return -1;
				}

				if (a.name.toLowerCase() < b.name.toLowerCase()) {
					return 1;
				}

				return 0;
			});
		},
		currentClient () {
			const storeClient = this.$store.getters['clients/current'];
			if (storeClient) {
				return storeClient;
			}
			else {
				this.$store.dispatch('clients/refresh');
				this.$store.commit('clients/current', this.$route.params.id);
				return this.$store.getters['clients/current'];
			}
		},
		canView () {
			return this.$store.getters['auth/hasPermission']('view_client', true, parseInt(this.$route.params.id)) || this.canManage;
		},
		canManage () {
			return this.$store.getters['auth/hasPermission']('manage_client*', true, parseInt(this.$route.params.id));
		},
		/**
		 * get the number of groups in the sidebar state for the current client
		 *
		 * @return number
		 */
		sidebarGroupCountForClient () {
			return this.$store.getters['sidebar/getClientGroupCount'](this.$route.params.id);
		}
	},
	/**
	 * component lifecycle event
	 *
	 * when the component is destroyed, we want to clear
	 * the timeout, so we are not making api calls when
	 * the sidebar is not present.
	 *
	 * @return void
	 */
	destroyed () {
		clearTimeout(this.refreshTimer);
	}
};
</script>

<style lang="scss">
@import '../../variables';

.app-section-contents {
	margin-left: $section-sidebar-width;
}

.pointer {
	cursor: pointer;
}

.client-text {
	color: #001786;
}
</style>
